export default function (context, val) {
    let form = context.state.form;
    context.commit('set_form', {
        PaymentDirection: val,
        DocumentNumber: val === 0 ? context.state.system.IncomePaymentNumber : context.state.system.OutcomePaymentNumber,
    });
    if (!context.rootGetters['dictionary/paymentOperation/list']) return;
    if (form.AgreementCodes.length > 0) {
        let operation = context.rootGetters['dictionary/paymentOperation/list'](val, form.ContragentType)[0];
        context.dispatch('change_PaymentOperationID', operation.value);
    } else {
        context.dispatch('change_PaymentOperationID', context.rootGetters['dictionary/paymentOperation/list'](val)[0].value);
    }
    context.dispatch('agreement_sums');
}